import { IAttributes } from "types/attributes/attributes.types";
import { GET_ATTRIBUTES_FAILURE, GET_ATTRIBUTES_REQUEST, GET_ATTRIBUTES_SUCCESS, GetAttributesFailureAction, GetAttributesRequestAction, GetAttributesSuccessAction } from "./attributes.types";

export const getAttributesRequest = (): GetAttributesRequestAction => ({
    type: GET_ATTRIBUTES_REQUEST,
    payload: {}
});

export const getAttributesSuccess = (response: IAttributes): GetAttributesSuccessAction => ({
    type: GET_ATTRIBUTES_SUCCESS,
    payload: response
});

export const getAttributesFailure = (error: string): GetAttributesFailureAction => ({
    type: GET_ATTRIBUTES_FAILURE,
    payload: error
});